import { Link } from "react-router-dom";
import { CheckCircle } from "lucide-react";

const Obrigado = () => {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="max-w-lg text-center">
        <CheckCircle className="w-16 h-16 text-primary mx-auto mb-6" />
        
        <h1 className="text-3xl md:text-4xl font-display font-normal mb-4 text-foreground">
          Recebemos sua solicitação!
        </h1>
        
        <p className="text-base md:text-lg text-muted-foreground font-body leading-relaxed mb-8">
          Analisamos todas as solicitações individualmente. Caso haja alinhamento com o seu perfil, 
          entraremos em contato em breve para agendar sua conversa de diagnóstico patrimonial.
        </p>
        
        <Link
          to="/"
          className="inline-flex items-center gap-2 bg-primary text-primary-foreground px-6 py-3 rounded-full text-sm font-medium transition-all hover:bg-primary/90"
        >
          Voltar ao início
        </Link>
      </div>
    </div>
  );
};

export default Obrigado;
